const IconHeartFilled = (): JSX.Element => {
  return (
    <>
      <path
        d="M11.9988 5.34313C13.5488 3.63973 16.0816 3.03459 18.3006 3.87634L18.5598 3.98219L18.5623 3.98345L18.8345 4.11073C20.1736 4.77743 21.2067 5.89885 21.6329 7.35935C22.0882 8.92022 21.8077 10.7197 20.7189 12.546C19.2163 15.0706 16.8558 16.9478 12.578 20.0905L12.0199 20.5L11.4619 20.0905C7.18081 16.9454 4.82775 15.0732 3.2825 12.558L3.2794 12.553L3.27567 12.5473C2.18514 10.7184 1.91237 8.9175 2.37099 7.35746C2.82825 5.80226 3.97143 4.63101 5.4298 3.98471L5.43352 3.98282L5.43786 3.98093C7.7288 2.99184 10.3993 3.58561 11.9988 5.34313Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconHeartFilled;
